import {
    ComponentFactoryResolver,
    ComponentRef,
    ContentChildren,
    Directive,
    OnDestroy,
    OnInit,
    QueryList,
    Type
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CessionAsideComponent } from '../components/aside/cession-aside/cession-aside.component';
import { FrontierReadonlyComponent } from '../components/aside/frontier-readonly/frontier-readonly.component';
import { GenericAsideComponent } from '../components/aside/generic-aside/generic-aside.component';
import { MenuAsideComponent } from '../components/aside/menu-aside/menu-aside.component';
import { MotorConfigAsideComponent } from '../components/aside/motor-config-aside/motor-config-aside.component';
import { MotorReadonlyComponent } from '../components/aside/motor-readonly/motor-readonly.component';
import { PartyEditAsideComponent } from '../components/aside/party-edit-aside/party-edit-aside.component';
import { PropertyConfigAsideComponent } from '../components/aside/property-config-aside/property-config-aside.component';
import { PropertyReadonlyComponent } from '../components/aside/property-readonly/property-readonly.component';
import { SidenavService } from '../service/sidenav.service';
import { AsideAction, SidenavAction, SidenavSide, SidenavTemplate } from '../store/aside.action';
import { DynamicAsideContentDirective } from './dynamic-aside-content.directive';

@Directive({
    selector: '[appDynamicAside]',
})
export class DynamicAsideDirective implements OnInit, OnDestroy {

    @ContentChildren(DynamicAsideContentDirective, {descendants: true}) asideHost: QueryList<DynamicAsideContentDirective>;
    componentRef: ComponentRef<any>;
    subscriptions: Subscription[] = [];

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private sidenavService: SidenavService,
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.sidenavService.actions.subscribe(action => this.parse(action))
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    parse(action: AsideAction.Generic) {
        const sidenav = action.side === SidenavSide.LEFT
            ? this.asideHost.first
            : this.asideHost.last;

        switch (action.type) {
            case SidenavAction.TOGGLE:
                sidenav.aside.toggle();
                break;
            case SidenavAction.OPEN:
                sidenav.aside.opened
                    ? sidenav.aside.close().then(() => this.open(sidenav, this.mapComponent(action.template)))
                    : this.open(sidenav, this.mapComponent(action.template));

                break;
            case SidenavAction.CLOSE:
                if (sidenav.aside.opened) {
                    sidenav.aside.close()
                        .then(() => this.componentRef.destroy());
                }
                break;
        }
    }

    private open(sidenav: DynamicAsideContentDirective, component: Type<any>) {
        sidenav.viewContainerRef.clear();
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
        this.componentRef = sidenav.viewContainerRef.createComponent(componentFactory);
        sidenav.aside.open();
    }

    private mapComponent(template: SidenavTemplate) {
        const map = {};
        map[SidenavTemplate.GENERIC_ASIDE] = GenericAsideComponent;
        map[SidenavTemplate.OFFER_PROPERTY_CONFIG] = PropertyConfigAsideComponent;
        map[SidenavTemplate.OFFER_MOTOR_CONFIG] = MotorConfigAsideComponent;
        map[SidenavTemplate.OFFER_PROPERTY_READONLY] = PropertyReadonlyComponent;
        map[SidenavTemplate.OFFER_MOTOR_READONLY] = MotorReadonlyComponent;
        map[SidenavTemplate.OFFER_FRONTIER_READONLY] = FrontierReadonlyComponent;
        map[SidenavTemplate.PARTY_EDITOR] = PartyEditAsideComponent;
        map[SidenavTemplate.CESSION_EDITOR] = CessionAsideComponent;
        map[SidenavTemplate.MENU] = MenuAsideComponent;
        return map[template];
    }
}
